import React from 'react';
import { useTranslation } from '../../context/LanguageContext';
import { useLocalizedSettings } from '../../hooks/useLocalizedSettings';
import background from '../../assets/images/background.webp';

/**
 * Home — Hero / intro section.
 * Full-bleed background image with headline, subtitle, and primary/secondary CTAs.
 */
export const HomeIntroSection = () => {
    const { t } = useTranslation();
    const { phoneHref } = useLocalizedSettings();

    return (
        <section
            className="relative h-[32rem] sm:h-[38rem] md:h-[42rem] lg:h-[70vh] lg:max-h-[760px] overflow-hidden"
            id="intro"
        >
            {/* No bg-fixed: it sizes `cover` against the viewport, which
                upscaled the 1440×696 source to 1862×900 and cropped it. */}
            <div
                className="absolute inset-0 bg-no-repeat bg-cover bg-center"
                style={{ backgroundImage: `url(${background})` }}
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />
            <div className="relative w-full h-full flex flex-col justify-center items-center text-center px-4 sm:px-8">
                <div className="max-w-3xl">
                    <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl text-white font-bold mb-4 sm:mb-6 leading-tight tracking-tight">
                        {/* One text node per line — react-snap merges adjacent
                            text nodes, which breaks hydration. */}
                        {`${t('hero.title')} `}
                        <br />
                        {t('hero.titleLine2')}
                    </h1>
                    <p className="text-base sm:text-lg md:text-xl text-gray-200 font-medium mb-8 sm:mb-10 tracking-wide">
                        {t('hero.subtitle')}
                    </p>
                    <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                        <a href={phoneHref}
                           className="px-8 py-3.5 bg-gold text-white font-bold rounded-full hover:bg-gold-dark transition-all shadow-lg hover:shadow-xl text-base sm:text-lg">
                            {t('hero.cta')}
                        </a>
                        <a href="#service-section"
                           className="px-8 py-3.5 border-2 border-white text-white font-bold rounded-full hover:bg-white hover:text-gray-800 transition-all text-base sm:text-lg">
                            {t('hero.ctaSecondary')}
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

